import { FETCH_SCENARIO_COMP_METRICS_BAR_CHARTS } from '../../../../../constants';
import { axios } from '../../../../../lib';

export default function fetchScenarioCompMetricsBarChart(
  sourceId: number,
  scenariosWithOrderOfSelection: any,
  isTargetEnabled: boolean,
) {
  return axios
    .post(`${FETCH_SCENARIO_COMP_METRICS_BAR_CHARTS}${sourceId}/`,
      {
        ...scenariosWithOrderOfSelection,
        currency_toggle: isTargetEnabled
      })
    .then<{ scenarios: []; metrics_values: object; toggle: [] }>((response) => {
      // eslint-disable-next-line prefer-const
      let scenarioComparisonData = JSON.parse(JSON.stringify(response.data));
      scenarioComparisonData.scenarios.sort((FirstScenario, SecondScenario) => FirstScenario.order - SecondScenario.order);
      scenarioComparisonData.scenarios.map((e) =>
        e.metrics.sort((a, b) =>
          a.placement_order > b.placement_order ? 1 : -1
        )
      );
      return scenarioComparisonData;
    });
}
